module.exports = __webpack_public_path__ + "img/Historia II.4ae7377c.png";